import React, { useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

require("./FloatLabel.module.less");
interface Props {
  children: JSX.Element | JSX.Element[];
  label: string;
  text: string;
  float: boolean;
  required: boolean;
  className: string;
}

export default function FloatLabel(props: Props) {
  const { children, label, text, float, required, className } = props;
  const [focus, setFocus] = useState(false);

  const classContainer = cn({
    "label-container": true,
    "label-container--float": float,
  });

  const classLabel = cn({
    label: true,
    "label--float": focus || float,
    "label--required": required,
  });
  const classImput = cn({
    label: true,
  });
  const classDate = cn({
    date: true,
  });

  return (
    <>
      <div
        onBlur={() => setFocus(false)}
        onFocus={() => setFocus(true)}
        className={`${classContainer} ${className}`}
      >
        {children}

        <div className={classLabel}>
          {label}
          <span></span>
          <div className={classDate}>{text}</div>
          {required && <span>*</span>}
        </div>
      </div>
    </>
  );
}

FloatLabel.propTypes = {
  label: PropTypes.string.isRequired,
  float: PropTypes.bool.isRequired,
  required: PropTypes.bool,
};

FloatLabel.defaultProps = {
  required: false,
};
